import React from "react";
import MyProfile from "../components/MyProfile/MyProfile";

function MyProfilePage() {
  return <MyProfile />;
}

export default MyProfilePage;
